import { render, staticRenderFns } from "./ReportWrapper.vue?vue&type=template&id=2cbb3616&"
import script from "./ReportWrapper.vue?vue&type=script&lang=ts&"
export * from "./ReportWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports